import type { TranslationKey } from '@/i18n';

export const blockedSettingsStrings = {
  goBack: 'common.goBack',
  title: 'settings.blocked',
  empty: 'settings.blockedEmpty',
  unblock: 'settings.blockedUnblock',
  confirmTitle: 'settings.blockedConfirmTitle',
  confirmBody: 'settings.blockedConfirmBody',
  failed: 'settings.blockedFailed',
} as const satisfies Record<string, TranslationKey>;

/**
 * Translation context:
 * Owned by `src/app/settings/blocked.tsx`, the list of people the user has
 * blocked and the only place a block can be lifted. `title` is the screen
 * heading and also the label of the row that opens it; `subtitle` explains what
 * unblocking does; `empty` is shown when nobody is blocked; `unblock` is the
 * button; `confirmTitle` and `confirmBody` are the confirmation dialog, with
 * `{{name}}` the blocked person's display name; `failed` is the error notice.
 *
 * `confirmBody` is the only place the app explains what lifting a block does,
 * and every claim in it is load-bearing. "Nothing is deleted" is a promise about
 * message history and is literally true — unblocking restores the same
 * conversation rather than starting a new one, so do not soften it into "you can
 * start again". The rest describes the ONLY route back into contact: the thread
 * stays inactive, the person who lifted the block is the only one who may ask to
 * reopen it, and the other person must accept. It must not promise that the two
 * will see each other again — a pair with a conversation is excluded from each
 * other's Available People permanently, whatever the block does.
 *
 * The screen used to open with a subtitle making exactly that false promise
 * ("puts you both back in each other's list"), and a `confirmBody` that offered
 * a Cue as the way back. Both were true before the reopen-only-by rule and
 * neither was true after. The subtitle is gone; this note is why it must not
 * come back.
 */
